import { highlightKeywords } from "./jobKeywords";

export default function HighlightedText({ text }: { text: string }) {
  const segments = highlightKeywords(text);
  return (
    <>
      {segments.map((seg, i) =>
        seg.category === "tech" ? (
          <mark key={i} className="bg-[var(--highlight-tech-bg)] text-[var(--highlight-tech-text)] not-italic font-medium rounded px-0.5">
            {seg.text}
          </mark>
        ) : seg.category === "soft" ? (
          <mark key={i} className="bg-[var(--highlight-soft-bg)] text-[var(--highlight-soft-text)] not-italic font-medium rounded px-0.5">
            {seg.text}
          </mark>
        ) : (
          <span key={i}>{seg.text}</span>
        )
      )}
    </>
  );
}
